import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const FleetPage = lazy(() => import('../pages/fleet/page'));
const VehicleDetailPage = lazy(() => import('../pages/vehicle-detail/page'));
const CartPage = lazy(() => import('../pages/cart/page'));
const CheckoutPage = lazy(() => import('../pages/checkout/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const PoliciesPage = lazy(() => import('../pages/policies/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const WeddingPackagesPage = lazy(() => import('../pages/wedding-packages/page'));
const VehiclesForSalePage = lazy(() => import('../pages/vehicles-for-sale/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    Component: HomePage
  },
  {
    path: '/flota',
    Component: FleetPage
  },
  {
    path: '/vehiculo/:id',
    Component: VehicleDetailPage
  },
  {
    path: '/carrito',
    Component: CartPage
  },
  {
    path: '/checkout',
    Component: CheckoutPage
  },
  {
    path: '/nosotros',
    Component: AboutPage
  },
  {
    path: '/politicas',
    Component: PoliciesPage
  },
  {
    path: '/contacto',
    Component: ContactPage
  },
  {
    path: '/paquetes-boda',
    Component: WeddingPackagesPage
  },
  {
    path: '/vehiculos-en-venta',
    Component: VehiclesForSalePage
  },
  {
    path: '*',
    Component: NotFound
  }
];

export default routes;
